import { SvgIcon, Tab, TabBar } from '@salecycle/ui-component-library';
import styled from 'styled-components';
import { CampaignEditorTab, useActiveTab } from '../hooks/useActiveTab';
import { useTranslation } from 'react-i18next';
import { useNavigateToAudience } from '../hooks/useNavigateToAudience';
import { useNavigateToScheduling } from '../hooks/useNavigateToScheduling';
import { useNavigateToContent } from '../hooks/useNavigateToContent';
import { CampaignStatus } from './CampaignStatus';

const Container = styled.div`
  padding: 0 40px 0 40px;
  display: grid;
  grid-template-areas: 'rightSide centerSide leftSide';
  border-bottom: 1px solid #d6deea;
  > div + div {
    > div {
      > div {
        padding-top: 0;
      }
    }
  }
  @media (max-width: 768px) {
    grid-template-areas:
      'rightSide leftSide'
      'centerSide centerSide';
  }
`;

const CenterContent = styled.div`
  display: flex;
  grid-area: centerSide;
  justify-content: center;
`;

const LeftSide = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  grid-area: leftSide;
  min-width: 76px;
`;

export const RightSide = styled.div`
  display: flex;
  grid-area: rightSide;
  align-items: center;
  justify-content: end;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
  @media (min-width: 768px) {
    gap: 16px;
  }
  button {
    @media (max-width: 768px) {
      width: 100%;
      :hover {
        margin-bottom: 10px;
      }
    }
  }
`;

export const CampaignTabs = () => {
  const { t } = useTranslation('campaigns');

  const activeTab = useActiveTab();

  const onAudienceClicked = useNavigateToAudience();
  const onContentClicked = useNavigateToContent();
  const onShedulingClicked = useNavigateToScheduling();

  return (
    <Container>
      <CenterContent>
        <TabBar topPadding={0}>
          <Tab
            selected={activeTab === CampaignEditorTab.Audience}
            onClick={onAudienceClicked}
            padding="8px 16px 0 16px"
            margin="0 8px 0 0"
            hasIcon
          >
            <SvgIcon name="users" />
            <span>{t('bulkRetargetingCampaigns.editor.tabs.audience')}</span>
          </Tab>

          <Tab
            selected={activeTab === CampaignEditorTab.Content}
            onClick={onContentClicked}
            padding="8px 16px 0 16px"
            margin="0 8px 0 0"
            hasIcon
          >
            <SvgIcon name="envelopes-bulk" />
            <span>{t('bulkRetargetingCampaigns.editor.tabs.content')}</span>
          </Tab>

          <Tab
            selected={activeTab === CampaignEditorTab.Scheduling}
            onClick={onShedulingClicked}
            padding="8px 16px 0 16px"
            margin="0 8px 0 0"
            hasIcon
          >
            <SvgIcon name="calendar-clock-regular" />
            <span>{t('bulkRetargetingCampaigns.editor.tabs.scheduling')}</span>
          </Tab>
        </TabBar>
      </CenterContent>
      <LeftSide>
        <CampaignStatus />
      </LeftSide>
    </Container>
  );
};
